import { View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout } from "@pimo/pimo-components/src/lib/layouts/drag-and-drop-layout/drag-and-drop-layout";
import {
  PMBarChartCard,
  PMDonutChartCard,
} from "@pimo/pimo-components/src/lib/pm-components";

import { TestAppState } from "../../../app";
import { DONUT_CARD_LAYOUT } from "../../../constants";
import {
  getAllReportingItems,
  getArrayFieldData,
  withTotalInTitle,
} from "../../../helpers/pages-helpers/dashboard-plugin-helpers";

/**
 * The bar and donut chart pair showing systems per process step (#2222) —
 * hand-duplicated copies of the same data before this split.
 */
export function addProcessStepChartsCard(
  view: View<TestAppState, DragAndDropLayout>
): void {
  const processStepsBarChartComponent = view.addComponent({
    component: PMBarChartCard,
    layoutProps: {
      componentId: "processStepsDashboardBarChartComponent",
      labels: ["barChart", "chart", "processStep"],
      description: "Shows systems grouped by process step across all projects.",
      title: "Systems per Process Step",
    },
  });

  processStepsBarChartComponent.mapState(({ dashboard }) => {
    const allItems = getAllReportingItems(dashboard);
    const { entries } = getArrayFieldData(
      allItems,
      (item) => item.basicItem?.processSteps
    );

    return {
      title: "Systems per Process Step",
      categories: entries.map((entry) => entry.label),
      data: entries.map((entry) => entry.count),
      chartType: 1 as const,
      xLabel: "Systems",
      yLabel: "Process Step",
      colors: entries.map((entry) => entry.color),
      fixedHeight: "320px",
    };
  });

  const processStepsDonutChartComponent = view.addComponent({
    component: PMDonutChartCard,
    layoutProps: {
      componentId: "processStepsDashboardDonutChartComponent",
      labels: ["donutChart", "chart", "processStep"],
      description: "Shows systems grouped by process step across all projects.",
      title: "Systems per Process Step ",
    },
  });

  processStepsDonutChartComponent.mapState(({ dashboard }) => {
    const allItems = getAllReportingItems(dashboard);
    const { entries } = getArrayFieldData(
      allItems,
      (item) => item.basicItem?.processSteps
    );

    return {
      title: withTotalInTitle("Systems per Process Step", allItems.length),
      icon: "DonutLarge",
      ...DONUT_CARD_LAYOUT,
      data: entries.map((entry) => ({
        label: entry.label,
        value: entry.count,
        color: entry.color,
      })),
    };
  });
}
